import { Button, Form, FormInstance, Input, Modal, Select, Switch } from 'antd'
import { FormProps, useForm } from 'antd/lib/form/Form'
import React, { useEffect, useState, useRef } from 'react'
import useToast from '../../hook/useToast'
import { mixPostV2 } from '../../services/mixin'
import { CloseOutlined } from "@ant-design/icons";
interface Props {
  show: boolean
  hideStatus?: boolean
  modalClose?: () => void
  onSubmitted?: () => void
  // onSubmitted?: (values: any) => void // if you want to pass form values
  source?: any
  sourceId?: any
  keyConfiguration?: any
  categorySourceColumnWarehouses?: any
  groupId: number
  listData: any[]
  dfCat?: any
}

type FieldType = {
  status: boolean
  code: string
  name: string
  // system: any[]
}

const CreateSystemParamModal: React.FC<Props> = (props) => {
  const { show, hideStatus = false, modalClose, onSubmitted, source, sourceId, keyConfiguration, categorySourceColumnWarehouses, groupId, listData, dfCat } = props
  const [visible, setVisible] = useState(show)
  const [form] = useForm()
  const formRef = useRef<FormInstance>(null);
  const pushToast = useToast()
  const [categorySourceColumnWarehousesState, setCategorySourceColumnWarehousesState] = useState([] as any)
  useEffect(() => {
    const filteredCategory = categorySourceColumnWarehouses.filter((item: any) => item.category_source_group_id === groupId)
    setCategorySourceColumnWarehousesState(filteredCategory)
  }, [groupId, show])

  useEffect(() => {
    setEditDataJson([])
    setVisible(show)
  }, [show])

  useEffect(() => {
    // form.setFieldValue('system', sourceId ? [sourceId] : null)
    if(dfCat) {
      const findCat = categorySourceColumnWarehousesState.find((item: any) => item.id === dfCat)
      formRef.current?.setFieldValue('category', findCat ? [findCat.id] : [])
    } else {
      formRef.current?.setFieldValue('category', [])
    }
  }, [dfCat, show, categorySourceColumnWarehousesState])

  // useEffect(() => {
  //   form.setFieldValue('system', sourceId ? [sourceId] : null)
  // }, [sourceId])

  // CLOSE MODAL
  const onClose = () => {
    setVisible(false)
    if (modalClose) {
      modalClose()
    }
  }

  // SUBMIT FORM
  const [formLoading, setFormLoading] = useState(false)
  const submitForm: FormProps<FieldType>['onFinish'] = async (values: any) => {
    const listSource = [] as any
    if (values.system && values.system.length > 0) {
      values.system.map((val: any) => {
        listSource.push({
          source_id: val,
        })
        return true
      })
    }

    const listCategory = [] as any
    values.category.map((val: any) => {
      listCategory.push({
        category_source_column_warehouse_id: val,
      })
      return true
    })
    const params = {
      name: values.name,
      is_active: values.status,
      code: values.code,
      list_category_source_column_id: JSON.stringify(listCategory),
    } as any

    if (groupId === 3) {
      params.json = JSON.stringify(editDataJson)
      params.is_required = values.is_required ? 1 : 0
      params.list_source_id = JSON.stringify(listSource)
    }

    setFormLoading(true)
    const res = await mixPostV2('/api/v1/be/source_column_warehouse', params)
    setFormLoading(false)
    if (res.status) {
      setVisible(false)
      form.resetFields()
      pushToast('Tạo param thành công', 'success')

      if (onSubmitted) {
        onSubmitted()
        // onSubmitted(values) // if you want to pass form values
      }
    } else {
      const er = res.error[Object.keys(res.error)[0]]
      pushToast(er, 'warning')
    }
  }
  const [tagInputAction, setTagInputAction] = useState(false)
  const [editDataJson, setEditDataJson] = useState([] as any)

  return (
    <Modal
      open={visible}
      title='Tạo param hệ thống'
      className='rs-modal w-400 footer-content-end'
      keyboard={false}
      centered
      footer={() => (
        <>
          <Button
            className="rs-button"
            onClick={onClose}
          >Hủy</Button>
          <Button
            type="primary"
            className="rs-button"
            loading={formLoading}
            onClick={() => { form.submit() }}
          >Tạo</Button>
        </>
      )}
      onCancel={onClose}
      afterOpenChange={() => { form.setFieldValue('status', true) }}
    >
      <Form
        form={form}
        ref={formRef}
        layout='vertical'
        className='rs-form'
        requiredMark={false}
        onFinish={submitForm}
      >
        {/* <Form.Item
          name='code'
          label='Mã'
          rules={[
            {
              required: true,
              message: 'Vui lòng chọn mã'
            }
          ]}
        >
          <Select
            className='rs-select'
            placeholder='Chọn mã'
            showSearch
            allowClear
            filterOption={(input, option) => {
              const normalize = (s: any) =>
                String(s ?? '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/đ/g, 'd')
                  .replace(/Đ/g, 'D')
                  .toLowerCase()

              const label = option?.label ?? option?.children ?? option?.value ?? ''
              return normalize(label).includes(normalize(input))
            }}
            options={keyConfiguration ? keyConfiguration.map((val: any) => ({ label: val.value_key, value: val.name_key })) : []}
          />
        </Form.Item> */}

        <Form.Item
          name='code'
          label='Mã'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập Mã'
            }
          ]}
        >
          <Input
            className='rs-input rs-input--32'
            placeholder='Mã'
          />
        </Form.Item>

        <Form.Item
          name='name'
          label='Tên Param'
          rules={[
            {
              required: true,
              message: 'Vui lòng nhập Tên Param'
            }
          ]}
        >
          <Input
            className='rs-input rs-input--32'
            placeholder='Tên Param'
          />
        </Form.Item>
        {groupId === 3 &&
          <div className="d-flex flex-column gap-1">
            <p className="text-sm  font-regular text-344054">Excel mapping</p>
            <div className="list-tag-excel">
              {editDataJson.map((item: any, index: number) => (
                <div key={index} className="tag-item">
                  <div className="text">{item}</div>
                  <div className="icon-svg delete-icon" onClick={() => {
                    const newList = [...(editDataJson || [])];
                    newList.splice(index, 1);
                    formRef?.current?.setFieldsValue({ json: newList });
                    // Cập nhật editData nếu cần thiết
                    setEditDataJson(newList);
                  }}>
                    <CloseOutlined />
                  </div>
                </div>
              ))}
              <div className="tag-item-input">
                {tagInputAction ? (
                  <Input
                    autoFocus
                    className="input-tag"
                    onBlur={(e) => {
                      const value = e.target.value.trim();
                      const findData = listData.find((x: any) => x.json.includes(value)) as any
                      if (findData) {
                        pushToast(`Giá trị <b>${value}</b> đã được gán cho Param "${findData.name}"`, "warning")
                        setTagInputAction(false);
                        return;
                      }
                      if (value) {
                        const newList = [...(editDataJson || []), value];
                        formRef?.current?.setFieldsValue({ json: newList });
                        // Cập nhật editData nếu cần thiết
                        setEditDataJson(newList);
                      }
                      setTagInputAction(false);
                    }}
                    onPressEnter={(e) => {
                      const value = (e.target as HTMLInputElement).value.trim();
                      const findData = listData.find((x: any) => x.json.includes(value)) as any
                      if (findData) {
                        pushToast(`Giá trị "${value}" đã được gán cho Param "${findData.name}"`, "warning")
                        setTagInputAction(false);
                        return;
                      }
                      if (value) {
                        const newList = [...(editDataJson || []), value];
                        formRef?.current?.setFieldsValue({ json: newList });
                        // Cập nhật editData nếu cần thiết
                        setEditDataJson(newList);
                      }
                      setTagInputAction(false);
                    }}
                  />
                ) : (
                  <span onClick={() => setTagInputAction(true)}>+ Thêm</span>
                )}
              </div>
            </div>
          </div>
        }

        {/* <Form.Item
          name='note'
          label='Ghi chú'
        >
          <Input.TextArea
            className='rs-input rs-input--32'
            placeholder='Ghi chú'
          />
        </Form.Item> */}

        {groupId === 3 &&
          <Form.Item
            name='system'
            label='Chọn hệ thống'
            rules={[
              {
                required: true,
                message: 'Vui lòng chọn hệ thống'
              }
            ]}
          >
            <Select
              className='rs-select v2'

              placeholder='Chọn hệ thống'
              mode='multiple'
              options={source ? source.map((val: any) => ({ label: val.name, value: val.id })) : []}
            />
          </Form.Item>
        }

        <Form.Item
          name='category'
          label='Nhóm'
          rules={[
            {
              required: true,
              message: 'Vui lòng chọn nhóm'
            }
          ]}
        >
          <Select
            className='rs-select v2'

            placeholder='Chọn nhóm'
            mode='multiple'
            options={categorySourceColumnWarehousesState ? categorySourceColumnWarehousesState.map((val: any) => ({ label: val.name, value: val.id })) : []}
            filterOption={(input, option) => {
              const normalize = (s: any) =>
                String(s ?? '')
                  .normalize('NFD')
                  .replace(/[\u0300-\u036f]/g, '')
                  .replace(/đ/g, 'd')
                  .replace(/Đ/g, 'D')
                  .toLowerCase()

              const label = option?.label ?? ''
              return normalize(label).includes(normalize(input))
            }}
          />
        </Form.Item>
        <Form.Item
          hidden={hideStatus}
          name='status'
          label='Trạng thái'
          valuePropName="checked"
          layout='horizontal'
          className='rs-form-item--horizontal'
        >
          <Switch className='rs-switch' />
        </Form.Item>
        {groupId === 3 &&
          <Form.Item
            hidden={hideStatus}
            name='is_required'
            label='Giá trị bắt buộc'
            valuePropName="checked"
            layout='horizontal'
            className='rs-form-item--horizontal'
          >
            <Switch className='rs-switch' />
          </Form.Item>
        }
      </Form>
    </Modal>
  )
}

export default CreateSystemParamModal
